module.exports = __webpack_public_path__ + "files/a9747f862c44c14895d2892c58ce534f.svg";